module.exports = __webpack_public_path__ + "static/media/TibetanGirl.8e92312b.jpg";